// extracted by mini-css-extract-plugin
module.exports = {"left":"MySaleDetailsPageContent_left__Q73qv","right":"MySaleDetailsPageContent_right__0qCRm","boxDetails":"MySaleDetailsPageContent_boxDetails__n1Zcy"};